import React, { memo, useMemo } from 'react';

import { Box, Button, Fade, Popper, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { confirmPopperIconMap } from './ConfirmPopperCDS.constants';
import {
  Arrow,
  getPopperContentStyles,
  getPopperStyles,
  popperBodyStyles,
  popperControlsStyles,
} from './ConfirmPopperCDS.styles';

const ConfirmPopperCDS = ({
  anchorEl = null,
  type,
  text,
  open = false,
  placement = 'top',
  onCancelClick,
  onConfirmClick,
  withControls = false,
}) => {
  const Icon = confirmPopperIconMap[type];

  const modifiers = useMemo(
    () => [
      {
        name: 'arrow',
        enabled: true,
      },
    ],
    [],
  );

  return (
    <Popper
      transition
      anchorEl={anchorEl}
      modifiers={modifiers}
      open={open}
      placement={placement}
      sx={getPopperStyles({ placement })}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Box sx={popperBodyStyles}>
            <Box sx={getPopperContentStyles({ type })}>
              <Icon size={IconSize[20]} />
              <Typography variant="regular16">{text}</Typography>
              <Arrow data-popper-arrow />
            </Box>
            {withControls && (
              <Box sx={popperControlsStyles}>
                <Button size="small" variant="line" onClick={onCancelClick}>
                  Cancel
                </Button>
                <Button size="small" type="submit" onClick={onConfirmClick}>
                  Confirm
                </Button>
              </Box>
            )}
          </Box>
        </Fade>
      )}
    </Popper>
  );
};

ConfirmPopperCDS.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  placement: PropTypes.string,
  open: PropTypes.bool,
  anchorEl: PropTypes.object,
  withControls: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onConfirmClick: PropTypes.func,
};

export default memo(ConfirmPopperCDS);
